import { ReactElement } from 'react'
import { Grid } from '@mui/material'

interface Props {
  elements: ReactElement[]
}

const DevelopusGrid = ({ elements }: Props): ReactElement => {
  return (
    <Grid
      container
      spacing={{ xs: 2, md: 3 }}
      columns={{ xs: 4, sm: 8, md: 12 }}
    >
      {elements.map((element, index) => (
        <Grid item xs={2} sm={4} md={4} key={index}>
          {element}
        </Grid>
      ))}
    </Grid>
  )
}

export default DevelopusGrid
